import { Injectable } from '@angular/core';
import { Observable, interval } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ClockService {
  getCurrentTime24h(): Observable<string> {
    return interval(1000).pipe(
      startWith(0),
      map(() =>
        new Date().toLocaleTimeString('es-CO', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        }),
      ),
    );
  }
}
